import { createElement, useEffect } from 'react'
import { useConfig } from '@ynap/immutables-provider'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('KlarnaOnSiteMessaging')
interface IProps {
    locale: Locale
    enabled?: boolean
    className?: string
    total: number
    dataKey?: string
}

const KlarnaOnSiteMessaging = (props: IProps) => {
    const { className, locale, total, dataKey = 'credit-promotion-auto-size' } = props

    useEffect(() => {
        window.Klarna?.OnsiteMessaging?.refresh?.()
    }, [total])

    const config = useConfig()
    const localeId = locale.id || 'en-GB'
    const [language, country] = localeId?.split('-')
    const availableLocale = config?.head.klarna?.express?.availability?.includes(localeId.toLocaleLowerCase())
        ? `${language.toLowerCase()}-${country.toUpperCase()}`
        : 'en-GB'

    return total
        ? createElement('klarna-placement', {
              'data-locale': availableLocale,
              'data-key': dataKey,
              'data-purchase-amount': total.toString(),
              class: bem(null, null, className),
          })
        : null
}

export default KlarnaOnSiteMessaging
